// @ts-ignore
import bash from 'react-syntax-highlighter/dist/esm/languages/prism/bash'
// @ts-ignore
import c from 'react-syntax-highlighter/dist/esm/languages/prism/c'
// @ts-ignore
import css from 'react-syntax-highlighter/dist/esm/languages/prism/css'
// @ts-ignore
import docker from 'react-syntax-highlighter/dist/esm/languages/prism/docker'
// @ts-ignore
import go from 'react-syntax-highlighter/dist/esm/languages/prism/go'
// @ts-ignore
import graphql from 'react-syntax-highlighter/dist/esm/languages/prism/graphql'
// @ts-ignore
import haskell from 'react-syntax-highlighter/dist/esm/languages/prism/haskell'
// @ts-ignore
import java from 'react-syntax-highlighter/dist/esm/languages/prism/java'
// @ts-ignore
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript'
// @ts-ignore
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json'
// @ts-ignore
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python'
// @ts-ignore
import scala from 'react-syntax-highlighter/dist/esm/languages/prism/scala'
// @ts-ignore
import typescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript'
// @ts-ignore
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light'
// @ts-ignore
import prismStyle from 'react-syntax-highlighter/dist/esm/styles/prism/tomorrow'

SyntaxHighlighter.registerLanguage('bash', bash)
SyntaxHighlighter.registerLanguage('c', c)
SyntaxHighlighter.registerLanguage('css', css)
SyntaxHighlighter.registerLanguage('docker', docker)
SyntaxHighlighter.registerLanguage('go', go)
SyntaxHighlighter.registerLanguage('graphql', graphql)
SyntaxHighlighter.registerLanguage('haskell', haskell)
SyntaxHighlighter.registerLanguage('java', java)
SyntaxHighlighter.registerLanguage('javascript', javascript)
SyntaxHighlighter.registerLanguage('json', json)
SyntaxHighlighter.registerLanguage('python', python)
SyntaxHighlighter.registerLanguage('scala', scala)
SyntaxHighlighter.registerLanguage('typescript', typescript)

export const Highlighter = SyntaxHighlighter
export const highlighterStyle = prismStyle
